<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="600"
	>
    <v-card>
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>business</v-icon> Nuevo recurso
				</v-flex>
				<v-chip label :color="form.id_estado === 1 ? 'success' : 'warning'" text-color="white" v-if="form.estado">
					{{ form.estado.descripcion }}
				</v-chip>
				<v-spacer></v-spacer>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-form
				@submit.prevent="save"
				v-model="valid"
				ref="form"
				lazy-validation
				>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs7>
								<v-text-field
									name="label"
									label="Descripción"
									v-model="form.descripcion"
									autofocus
									maxlength="50"
									:rules="$validate(['required'])"
									required
								></v-text-field>
							</v-flex>

							<v-flex xs5>
								<v-text-field
									name="ruta"
									label="Ruta"
									v-model="form.ruta"
									maxlength="50"
									:rules="$validate(['required'])"
									required
								></v-text-field>
							</v-flex>

							<v-flex xs6>
								<v-text-field
									:disabled="isPadre"
									name="icono"
									:label="$t('module.crud.icon')"
									v-model="form.icono"
									maxlength="30"
								></v-text-field>
							</v-flex>

							<v-flex xs3 class="text-xs-center">
								<v-icon v-if="form.icono !== ''" color="info" x-large>{{ form.icono }}</v-icon>
								<v-icon v-if="form.icono == null || form.icono == ''" color="error" x-large>clear</v-icon>
							</v-flex>

							<v-flex xs3>
								<v-text-field
									type="number"
									label="Nivel"
									v-model="form.nivel"
									:rules="$validate(['required'])"
									required
								></v-text-field>
							</v-flex>

						</v-layout>

						<h4>Dependencias</h4>
						<v-layout wrap>
							<v-flex xs6>
								<v-switch
								v-model="isPadre"
								:value="true"
								label="¿Depende de otro módulo?"
								color="info"></v-switch>
							</v-flex>
							<v-flex xs6>
								<v-autocomplete
									v-if="isPadre"
									:items="recursos"
									v-model="form.id_padre"
									label="Recurso padre"
									item-text="descripcion"
									item-value="id"
									:rules="$validate(['required'])"
									required
									></v-autocomplete>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<small class="error--text text-required">* Los campos son obligatorios</small>
					<v-spacer></v-spacer>
					<v-btn
						@click.native="close()">
						<v-icon>cancel</v-icon> {{$t('common.cancel') }}
					</v-btn>
					<v-btn
						color="primary"
						type="submit"
						:loading="loading"
						:disabled="!valid">
						<v-icon dark>check</v-icon> {{$t('common.save') }}
					</v-btn>
				</v-card-actions>
			</v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate';

export default {
	mixins: [validate],
	data () {
		return {
			dialog: false,
			form: {},
			valid: false,
			isPadre: false,
			recursos: [],
			rolSelected: 0,
			loading: false
		}
	},
	mounted () {
		this.$bus.$on('openDialogCrearRecurso', ({recursos, rolSelected}) => {
			console.log('recursos', recursos);
			this.rolSelected = rolSelected
			this.recursos = recursos
			this.dialog = true
		})
	},
	methods: {
		close () {
			this.form = {},
			this.loading = false
			this.isPadre = false
			this.valid = false
			this.$bus.$emit('closeDialog')
			this.dialog = false
		},
		async save () {
			if (this.$refs.form.validate()) {
				this.loading = true
				this.form.id_estado = 1
				this.form.id_rol = this.rolSelected
				this.form.nivel = parseInt(this.form.nivel)
				if (this.isPadre) {
					this.form.icono = null
				}
				try {
					let user = this.$storage.get('user')
					await this.$service.graphql({
						query: `
							mutation add($recurso: NewRecurso!){
								recursoAdd(recurso: $recurso){
									id
								}
							}
						`,
						variables: {
							recurso: this.form,
							roles: user.roles
						}
					})
				} catch (error) {
					console.log(error)
				}
				this.$message.success()
				this.loading = false
				this.close()
			}
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/rol-recurso/dialogs/CrearRecurso.vue